import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApoderadoSnapshot } from '../../models/constitution-snapshot.model';

@Component({
  selector: 'app-constitution-attorneys-readonly-table',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './constitution-attorneys-readonly-table.component.html',
  styleUrl: '../../../constitution-form/constitution-form.component.scss',
})
export class ConstitutionAttorneysReadonlyTableComponent {
  apoderados = input.required<ApoderadoSnapshot[]>();

  attorneySelected = output<ApoderadoSnapshot>();

  onRowClick(apoderado: ApoderadoSnapshot): void {
    this.attorneySelected.emit(apoderado);
  }

  onRowKeydown(event: KeyboardEvent, apoderado: ApoderadoSnapshot): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.attorneySelected.emit(apoderado);
    }
  }
}
